import React from 'react';

const PageHeader = ({ eyebrow, title, description, className = '' }) => {
  return (
    <div className={`text-center py-8 sm:py-12 md:py-16 px-4 ${className}`}>
      {eyebrow && (
        <div className="mb-3 sm:mb-4 text-xs sm:text-sm tracking-widest text-gray-500 uppercase">
          {eyebrow}
        </div>
      )}
      <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6" 
          style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700 }}>
        {title}
      </h1>
      {description && (
        <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
};

export default PageHeader;
